/* 11:11 Strength — Mystery Tee launch claim widget.
   Shows on the cart page: progress toward the free Mystery Tee
   (buy any 3 DROP03 pieces) and a size picker + claim button.
   The automatic BXGY discount zeroes the tee at checkout. */
(function () {
  'use strict';

  var DROP03_IDS = [10746425377046,10746424525078,10746423902486,10746421379350,10746417414422,10746415087894,10746410336534,10746405388566,10746401095958,10746392871190,10746156876054,10746147045654,10746120143126,10746116079894,10746106773782,10746099532054,10746096419094,10746086818070,10746033471766,10746029637910,10746027671830,10746014171414,10746008797462,10746005291286,10745992872214,10745992806678,10745991725334,10745988448534,10745984975126,10745931137302,10745930973462,10745930842390,10745930776854,10745930711318,10745930514710];
  var MYSTERY_PID = 15428434067734;
  var MYSTERY_VARIANTS = [
    { t: 'S', id: 67735794221334 },
    { t: 'M', id: 67735794254102 },
    { t: 'L', id: 67735794286870 },
    { t: 'XL', id: 67735794319638 },
    { t: '2XL', id: 67735794352406 }
  ];

  if (!/^\/cart\/?(\?.*)?$/.test(window.location.pathname)) return;

  var BOX_ID = 'm1111-mystery-claim';
  var selectedSize = 1; // default M

  function drop03Count(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if (DROP03_IDS.indexOf(it.product_id) !== -1) n += it.quantity;
    });
    return n;
  }
  function teeInCart(cart) {
    return (cart.items || []).some(function (it) { return it.product_id === MYSTERY_PID; });
  }

  function boxStyle() {
    return 'display:none;max-width:1200px;margin:0 auto 2rem;padding:1.6rem 2rem;' +
      'background:#0d0d0d;border:1px solid #2a2a2a;border-left:4px solid #8C3A21;' +
      'color:#E4DCCB;font-family:inherit;text-align:center;';
  }

  function buildBox() {
    var old = document.getElementById(BOX_ID);
    if (old) old.remove();
    var div = document.createElement('div');
    div.id = BOX_ID;
    div.setAttribute('style', boxStyle());
    div.innerHTML =
      '<div style="font-size:1.1rem;letter-spacing:.25em;font-weight:700;" id="m1111-claim-title">11:11 STRENGTH</div>' +
      '<div id="m1111-claim-msg" style="margin:.8rem 0 1.2rem;font-size:1.5rem;"></div>' +
      '<div id="m1111-claim-sizes" style="display:none;justify-content:center;gap:.6rem;margin-bottom:1.2rem;flex-wrap:wrap;"></div>' +
      '<button id="m1111-claim-btn" type="button" style="display:none;background:#8C3A21;color:#fff;' +
      'border:none;padding:1.1rem 3rem;font-size:1.4rem;letter-spacing:.2em;font-weight:700;cursor:pointer;">' +
      'CLAIM YOUR FREE TEE</button>';
    var main = document.querySelector('main#MainContent') || document.querySelector('main') || document.body;
    main.insertBefore(div, main.firstChild);
    return div;
  }

  function renderSizes(box) {
    var wrap = box.querySelector('#m1111-claim-sizes');
    wrap.innerHTML = '';
    wrap.style.display = 'flex';
    MYSTERY_VARIANTS.forEach(function (v, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = v.t;
      b.setAttribute('style', 'min-width:4.4rem;padding:.7rem .5rem;cursor:pointer;font-weight:700;' +
        (i === selectedSize
          ? 'background:#E4DCCB;color:#111;border:1px solid #E4DCCB;'
          : 'background:transparent;color:#E4DCCB;border:1px solid #555;'));
      b.addEventListener('click', function () {
        selectedSize = i;
        renderSizes(box);
      });
      wrap.appendChild(b);
    });
  }

  function claim(box, btn) {
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: MYSTERY_VARIANTS[selectedSize].id, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.reload();
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'CLAIM YOUR FREE TEE';
      box.querySelector('#m1111-claim-msg').textContent = 'Something jammed. Tap again — your tee is waiting.';
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = drop03Count(cart);
        var hasTee = teeInCart(cart);
        var box = document.getElementById(BOX_ID) || buildBox();
        var msg = box.querySelector('#m1111-claim-msg');
        var sizes = box.querySelector('#m1111-claim-sizes');
        var btn = box.querySelector('#m1111-claim-btn');

        if (hasTee) {
          box.style.display = 'block';
          msg.textContent = 'Mystery Tee secured. It goes to $0 at checkout.';
          msg.style.fontSize = '1.5rem';
          sizes.style.display = 'none';
          btn.style.display = 'none';
        } else if (n >= 3) {
          box.style.display = 'block';
          msg.innerHTML = 'You unlocked the <strong>MYSTERY TEE — FREE</strong>. Pick your size.';
          renderSizes(box);
          btn.style.display = 'inline-block';
          btn.onclick = function () { claim(box, btn); };
        } else if (n > 0) {
          box.style.display = 'block';
          var need = 3 - n;
          msg.textContent = 'Add ' + need + ' more DROP03 ' + (need === 1 ? 'piece' : 'pieces') + ' to unlock your FREE Mystery Tee.';
          msg.style.fontSize = '1.4rem';
          sizes.style.display = 'none';
          btn.style.display = 'none';
        } else {
          box.style.display = 'none';
        }
      })
      .catch(function () { /* cart unreadable — stay hidden */ });
  }

  function init() {
    buildBox();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
